var chunkMapping = {
	"796": [
		5427,
		9172
	]
};
var idToExternalAndNameMapping = {
	"5427": [
		"default",
		"./MenuBar",
		9330
	],
	"9172": [
		"default",
		"./store",
		9330
	]
};
var idToRemoteMap = {
	"5427": [
		{
			"externalType": "script",
			"name": "menu",
			"externalModuleId": 9330
		}
	],
	"9172": [
		{
			"externalType": "script",
			"name": "menu",
			"externalModuleId": 9330
		}
	]
};
__webpack_require__.federation.bundlerRuntimeOptions.remotes = {idToRemoteMap,chunkMapping, idToExternalAndNameMapping, webpackRequire:__webpack_require__};
__webpack_require__.f.remotes = (chunkId, promises) => {
	__webpack_require__.federation.bundlerRuntime.remotes({idToRemoteMap,chunkMapping, idToExternalAndNameMapping, chunkId, promises, webpackRequire:__webpack_require__});
}